export const columnDefs = [
  {
    field: 'select',
    dataType: 'select',
    headerName: '',
    headerCheckboxSelection: false,
    checkboxSelection: false,
  },
  {
    field: 'candidateName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'jobTitle',
    headerName: 'Position',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'hiringRequestId',
    headerName: 'Position ID',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'yearsOfExperience',
    headerName: 'Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'emailId',
    headerName: 'Email',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'earliestAvailability',
    headerName: 'Available By',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'createdDate',
    headerName: 'Received On',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'agingDays',
    headerName: 'Profile Aging',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'hiringManagerName',
    headerName: 'Hiring Manager',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'vendorName',
    headerName: 'Vendor',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'resume',
    headerName: 'Resume',
    filterParams: { hideMenu: true },
  },
  {
    field: 'attachments',
    headerName: 'Initial Screening Feedback',
    filterParams: { hideMenu: true },
  },
  {
    field: 'url',
    headerName: 'Links',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'status',
    headerName: 'Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'review',
    headerName: 'Review',
    filterParams: { hideMenu: true },
  },
  {
    field: 'history',
    headerName: 'History',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
];

export const columnsForExport = [
  { field: 'candidateName', headerName: 'Name' },
  { field: 'jobTitle', headerName: 'Position' },
  { field: 'hiringRequestId', headerName: 'Position ID' },
  { field: 'yearsOfExperience', headerName: 'Exp' },
  { field: 'emailId', headerName: 'Email' },
  { field: 'location', headerName: 'Location' },
  { field: 'earliestAvailability', headerName: 'Available By' },
  { field: 'createdDate', headerName: 'Received On' },
  { field: 'agingDays', headerName: 'Profile Aging' },
  { field: 'hiringManagerName', headerName: 'Hiring Manager' },
  { field: 'vendorName', headerName: 'Vendor' },
  { field: 'url', headerName: 'Links' },
  { field: 'status', headerName: 'Status' },
];
